import { useMemo } from 'react';
import { ReactComponent as MapFillIcon } from '../../icons/map.fill.svg';
import { getSiteType } from '@pocapan/shared/utils/SiteTypes';

interface LocationBoxProps {
  locationName: string;
  streetAddress: string;
  siteType: string;
  siteTypeRightPadding: number;
  isOpenNewTab: boolean;

  onClick: () => void; // Added onClick to Props
}

export const LocationBox: React.FC<LocationBoxProps> = ({
  locationName,
  streetAddress,
  siteType,
  siteTypeRightPadding = 0,
  onClick
}) => {
  const siteTypeName = useMemo(() => getSiteType(siteType).name,[siteType]);
  return (
    <div
      className="flex flex-row items-center p-[12px] rounded-[12px] border-[1px] border-separator-light-2 dark:border-separator-dark-1"
      onClick={onClick}
    >
      <div className="flex flex-col flex-1 gap-[5px]">
        <div className="flex flex-row items-center">
          <MapFillIcon className="mr-1 w-[14px] h-[14px] self-center fill-onTheirty-light dark:fill-onTheirty-dark" />
          <div className="font-semibold text-[15px] leading-[20px] text-main-light-2 dark:text-main-dark-2">
            {locationName}
          </div>
        </div>
        <div className="text-sub-light-2 dark:text-sub-dark-2 font-normal text-[13px]">
          {streetAddress}
        </div>
      </div>
      {siteTypeName && (
        <div
          className={`
            font-normal text-[12px] leading-[14px] h-[21px]
            px-[8px] py-[4px] rounded-[4px] ml-auto
            flex items-center justify-center
            text-center text-onLabel-light dark:text-onLabel-dark bg-surface-light dark:bg-surface-dark
          `}
          style={{ marginRight: siteTypeRightPadding }}
        >
          {siteTypeName}
        </div>
      )}
    </div>
  );
};
